import EventEmitter from "../../utils/eventEmitter";
import Axios from "../utils/axios"


export const loadPackageTypes = async () => {
  try {
    const response = await Axios.get('package-types');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};

const loadOnePackageTypes = async (name) => {
  try {
    const respnse = await Axios.get('package-types/'+name);
    const responseData = await respnse.data;
    return responseData;
  }catch (err) {
    throw err;
  }
}

export const loadPackageType = async (action) => {
  try {
    switch (action) {
      case 'new':
        // const response = await Axios.get('setups/product-categories');
        // const responseData = await response.data;
        // return {...responseData, category: {}};
        return {};
        
      default:
        const data = await loadOnePackageTypes(action);
        return data;
    }
  }catch (err) {
    throw err;
  }
}

const usePackageTypeAPI = () => {
  
  const create = async (data, success) => {
    try {
      const respnse = await Axios.post('package-types', data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('package_type_created', data.seo);
    }catch(err) {
      throw err;
    }
  }

  const update = async (seo, data, success) => {
    try {
      const respnse = await Axios.put('package-types/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('package_type_update', data.seo);
    }catch (err) {
      throw err;
    }
  }


  return { create, update };
};



export default usePackageTypeAPI;


